import Vue from 'vue';
import {ApckPropertyTable} from "../common/property_table";
import AjaxUtils from "../../util/ajax_utils";

const cred_types = {
    USERNAME_PASSWORD: 'USERNAME_PASSWORD',
    KEY_TOKEN: 'KEY_TOKEN',
}

export const CredentialManagerForm = {
    components: {
        'apck-property-table': ApckPropertyTable
    },
    props: {
        url: String,
        errors: {
            type: Object,
            default: () => {{}}
        },
        isLightbox: false,
        cred_type: {
            type: String,
            default: ""
        },
        newCred: Boolean,
    },
    computed: {
        credential_type_options() {
            const allOptions = [
                {'label': 'Username/Password', 'value': cred_types.USERNAME_PASSWORD},
                {'label': 'Key or Token', 'value': cred_types.KEY_TOKEN},
            ];
            if (!this.cred_type) {
                return allOptions;
            } else {
                return allOptions.filter((opt) => opt.value === this.cred_type);
            }
        }
    },
    data: function() {
        return {
            description: "",
            credential_type: cred_types.USERNAME_PASSWORD,
            header: "",
            header_value: "",
            email: "",
            username: "",
            password: "",
            jwt: "",
            expiry_date: "",
            value: "",
            credential: {},
            loaded: true,
            cred_types: Object.freeze(cred_types),
            user_password: "",
        };
    },
    methods: {
        save: function () {
            var cmp = this;

            let data = {
                'description': this.description,
                'credential_type': this.credential_type,
                'action': 'update',
                'user_password': this.user_password,
                'expiry_date': this.expiry_date,
            }

            if (this.credential_type === this.cred_types.USERNAME_PASSWORD) {
                data['username'] = this.username;
                data['password'] = this.password;
            } else if (this.credential_type === this.cred_types.KEY_TOKEN) {
                data['value'] = this.value;
            }

            cmp.loaded = false;
            // clear errors
            cmp.$emit('update:errors', {});

            AjaxUtils.ajax_post({
                url: this.url,
                data: JSON.stringify(data),
                success: function (json, status, xhr) {
                    cmp.loaded = true;
                    if (cmp.$globalFlags.spa) {
                        // TODO: cmp.$router.push({});
                    } else if (cmp.isLightbox) {
                        cmp.$emit("close");
                    } else {
                        window.location.href = `/credman`;
                    }
                },
                fail: function (json, status, xhr) {
                    cmp.$emit('update:errors', json?.field_errors ? json.field_errors : {})
                    cmp.loaded = true;
                }
            });
        }
    },
    template: `
        <div>
            <div class="cred-form">
                <apck-field :errors="errors?.description">
                    <apck-text
                        v-model="description"
                        label="Description"
                    />
                </apck-field>

                <apck-field>
                    <apck-select
                        v-model="credential_type"
                        label='Credential Type'
                        :options="credential_type_options"
                        :disabled="!newCred"
                    />
                </apck-field>

                <apck-field :errors="errors?.username" v-if="credential_type === cred_types.USERNAME_PASSWORD">
                    <apck-text
                        v-model="username"
                        label="Username"
                    />
                </apck-field>

                <apck-field :errors="errors?.password" v-if="credential_type === cred_types.USERNAME_PASSWORD">
                    <apck-password
                        v-model="password"
                        label="Password"
                        :show-password="true"
                    />
                </apck-field>

                <apck-field :errors="errors?.value" v-if="credential_type === cred_types.KEY_TOKEN">
                    <apck-text
                        v-model="value"
                        label="Key or Token"
                    />
                </apck-field>

                <apck-field :errors="errors?.expiry_date">
                    <apck-datetimepicker v-model="expiry_date" label="Expiry Date (Optional)" dateOnly allowClear />
                </apck-field>
            </div>

            <apck-button title="Save" value="Save" icon="fa-save" class="btn-positive" :handler="save" />
            <apck-mask :trigger="!loaded"/>
        </div>
    `
}

export const CredentialManagerFormSSR = {
    // credman form for the server-side rendered webgui-prod.
    // This is just a wrapper on the form to handle errors and loading field data
    props: {
        url: String,
        newCred: Boolean,
        isLightbox: false,
        skip_password_check: {
            type: Boolean,
            default: false,
        },
        not_shared: {
            type: Boolean,
            default: false,
        },
        cred_type: {
            type: String,
            default: ""
        },
    },
    data: function() {
        return {
            errors: {},
        };
    },
    methods: {
        loadCredDetails: function () {
            const cmp = this;
            let _loadCredDetails = function(passwordValue, failureMessage) {
                AjaxUtils.ajax_post({
                    url: cmp.url,
                    data: JSON.stringify({
                        user_password: passwordValue,
                    }),
                    success: function (resp) {
                        if (!resp.success) {
                            cmp.$dialog.alert(failureMessage, 'Failed');
                            return;
                        }
                        Object.assign(cmp.$refs.form.$data, resp.fields);
                        // pass password through to update form
                        Vue.set(cmp.$refs.form.$data, 'user_password', passwordValue);
                    },
                    opts: {
                        contentType: "application/x-www-form-urlencoded; charset=UTF-8",
                    }
                });
            }

            if (this.not_shared) {
                cmp.$dialog.alert('Organisation has not shared credential access', 'Failed');
            } else if (this.skip_password_check) {
                _loadCredDetails(null, "Failed to load credential, please try again.");
            } else {
                this.$dialog.promptPassword("Please enter your AppCheck login password to view the credentials.", "Password", '', function (passwordValue) {
                    _loadCredDetails(passwordValue, "Your password was incorrect, please try again.");
                });
            }
        }
    },
    mounted() {
        if (!this.newCred) {
            this.loadCredDetails();
        }
    },
    template: `
        <apck-cred-man-form ref="form" :url="url" :is-spa="false" :is-lightbox="isLightbox" :cred_type="cred_type" :newCred="newCred" :errors.sync="errors" @close="$emit('close')"></apck-cred-man-form>
    `
}
